import React from 'react';
import PageShell from '../../components/PageShell';
import { CTABanner } from '../../components/common/Primitives';
import LicenceFeeHighlight from '../../components/common/LicenceFeeHighlight';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../../components/ui/accordion';
import { SCHOOL_FAQ } from '../../lib/mockSchool';

export default function SchoolFAQ() {
  const d = SCHOOL_FAQ;
  return (
    <PageShell>
      {/* HERO */}
      <section className="px-6 pt-12 pb-8" data-testid="school-faq-hero">
        <div className="mx-auto max-w-[1240px]">
          <h1 className="text-[42px] md:text-[52px] font-extrabold leading-[1.06] tracking-tight text-navy">{d.hero.title}</h1>
          <p className="mt-5 max-w-2xl text-[15.5px] leading-relaxed text-ink-500">{d.hero.desc}</p>
          <div className="mt-6"><LicenceFeeHighlight /></div>
        </div>
      </section>

      {/* FAQs */}
      <section className="px-6 py-8" data-testid="school-faq-list">
        <div className="mx-auto max-w-[900px]">
          <Accordion type="single" collapsible className="space-y-3">
            {d.items.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl border border-canvas-200 bg-white shadow-soft data-[state=open]:shadow-card" data-testid={`school-faq-item-${i}`}>
                <AccordionTrigger className="px-5 py-4 text-left text-[15px] font-semibold text-navy hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="px-5 pb-4 text-[13.5px] text-ink-500">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA */}
      <section className="px-6 pb-24 pt-8">
        <div className="mx-auto max-w-[1240px]">
          <CTABanner title={d.cta.title} desc={d.cta.desc} primary={d.cta.primary} secondary={d.cta.secondary} />
        </div>
      </section>
    </PageShell>
  );
}
